(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller('shortageCriticalityConfig', shortageCriticalityConfig);

	shortageCriticalityConfig.$inject = ['$rootScope', '$scope', '$timeout', 'storeService'];

	function shortageCriticalityConfig($rootScope, $scope, $timeout, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;

		vm.showAddExclusionRule = true;
		vm.showAddCriticalityLevel = true;

		$scope.type = 'site';
		$scope.siteId = adminConfig.factory.id;
		$scope.customerId = adminConfig.customer.id;
		$scope.factoryName = adminConfig.factory.name;
	}
})();